<div class="row headerrow shadow font-size-15">
    <ng-content></ng-content>
</div>